import styled from "styled-components";
import Layout from "../components/Layout";
import Subscribe from "../components/Subscribe";
import Head from "next/head";

export default function NewsletterPage() {
  return (
    <Layout>
      <Head>
        <title>veikkanen - Subscribe</title>
      </Head>
      <NewsletterWrap>
        <NewsletterTitle>Keep in touch</NewsletterTitle>
        <Subscribe />
      </NewsletterWrap>
    </Layout>
  );
}

export const NewsletterTitle = styled.h1`
  font-family: var(--brandFont);
  color: var(--colorContentPrimary);
  margin: calc(var(--gridMarginGap) * 2);

  font-size: var(--step-3-5);
  font-weight: 300;

  text-align: center;

  grid-column: 1 / -1;

  @media screen and (min-width: 768px) {
  }
`;

const NewsletterWrap = styled.div`
  display: flex;

  display: grid;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;

  grid-template-columns: var(--gridTemplateColumnsDefault);
  column-gap: var(--gridColumnGap);
  grid-template-areas: "a a a a a a";

  padding: var(--gridMarginGap);

  min-height: calc(100vh - var(--gridMarginGap) * 4);

  @media screen and (min-width: 768px) {
    min-height: calc(100vh - var(--gridMarginGap) * 2);
    grid-template-areas: ". . . a a a a a a . . .";
  }
`;

export const IsolatedLink = styled.a`
  color: var(--colorContentPrimary);

  font-size: var(--step-3-5);
  font-weight: 300;

  &:hover {
    color: var(--colorContentSecondary);
    cursor: pointer;
  }
`;
